
class ClsHtml {

  static f_copyHtmlAsClipboard = function(div_element_id) {
    let copy_el = document.getElementById(div_element_id);
    var body = document.body, range, sel;
    if (document.createRange && window.getSelection) {
      range = document.createRange();
      sel = window.getSelection();
      sel.removeAllRanges();
      try {
        range.selectNodeContents(copy_el);
        sel.addRange(range);
      } catch (e) {
        range.selectNode(copy_el);
        sel.addRange(range);
      }
    } else if (body.createTextRange) {
      range = body.createTextRange();
      range.moveToElementText(copy_el);
      range.select();
    }
    document.execCommand("Copy");
  };

}
export { ClsHtml };
